import React from 'react';

import { Flex } from '@chakra-ui/react';

import { ChipSelect } from 'uiToolkitV1/ChipSelect';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ActiveArchiveSelector = ({
  filters,
  filterChangeHandler,
  filterId,
  activeArchiveCountData,
  isActiveArchiveCountLoading,
}) => {
  const TABLE_SELECT_OPTIONS = filters.map(({ sectionKeyName, sectionId, beKey }) => ({
    text: `${sectionKeyName} (${(activeArchiveCountData && activeArchiveCountData[beKey]) ?? 0})`,
    id: sectionId,
    keyName: sectionKeyName,
  }));

  const onFilterChange = (newFilterId) => {
    filterChangeHandler(newFilterId);
  };

  if (isActiveArchiveCountLoading) {
    return <SkeletonLoader />;
  }

  return (
    <Flex alignItems="center" mt="16px">
      <TextBodyMedium bold color="text.g3" mr={2}>
        Showing :
      </TextBodyMedium>
      <ChipSelect
        options={TABLE_SELECT_OPTIONS}
        onChange={onFilterChange}
        forceMinOneSelection
        selectedIds={[filterId]}
      />
    </Flex>
  );
};

export default ActiveArchiveSelector;
